"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.molarMassC12Dependencies = void 0;

var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");

var _dependenciesUnitClassGenerated = require("./dependenciesUnitClass.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var molarMassC12Dependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  UnitDependencies: _dependenciesUnitClassGenerated.UnitDependencies,
  createMolarMassC12: _factoriesAny.createMolarMassC12
};
exports.molarMassC12Dependencies = molarMassC12Dependencies;